import React from "react";

export default function BroadcastTickets() {
  return <div>Admin BroadcastTickets</div>;
}
